import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
export function FAQ() {
  const faqs = [{
    question: 'Why do only a small number of real estate agents close the majority of deals?',
    answer: 'Industry data confirms a small percentage of agents close most home sales. That 80/20 pattern reflects experience, strategy, and service quality. Our team focuses on being the 20% who perform, while saving sellers thousands with our 1% listing fee. High performance does not have to come at a high price.'
  }, {
    question: 'What should sellers know before selling their home?',
    answer: 'Sellers should understand current market conditions, properly prepare the home for showings, price it competitively, and be aware of all closing costs including commissions, title insurance, and potential repairs. Working with One Percent Listing AZ means you get full service support at a fraction of the traditional commission.'
  }, {
    question: 'What matters most when selling a home?',
    answer: 'Three things. Price, condition, and exposure. Your home must be priced correctly for the current market, presented in its best condition, and marketed effectively to qualified buyers. We excel in all three while saving you thousands in commission.'
  }, {
    question: 'What questions should I ask a realtor before working with them?',
    answer: 'Ask about their commission structure, how many homes they have sold in your area, their marketing strategy, how they will communicate with you, and what sets them apart. We are transparent about our 1% listing fee and happy to answer every question upfront.'
  }, {
    question: 'What adds most value when selling a home?',
    answer: 'Kitchen and bathroom updates typically return the best ROI. Fresh paint, updated fixtures, clean landscaping, and thorough decluttering also make a significant impact. Our team can advise you on cost-effective improvements that help your home sell faster and for more.'
  }, {
    question: 'Do sellers pay closing costs?',
    answer: 'Yes. Sellers typically pay real estate commissions, title insurance, transfer taxes, and potentially buyer concessions. With One Percent Listing AZ, you significantly reduce your commission expense, one of the largest closing costs, while still receiving full service representation.'
  }];
  return <section className="py-20 md:py-32 bg-cream" data-id="element-66">
      <div className="container mx-auto px-4 md:px-6" data-id="element-67">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-68">
          <p className="text-gold text-xs font-bold tracking-[0.2em] uppercase mb-4" data-id="element-69">
            Answers First
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal leading-tight" data-id="element-70">
            Questions sellers ask us most.
          </h2>
        </div>

        <div className="max-w-[900px] mx-auto bg-white p-6 md:p-10 rounded-sm border border-gold/20 shadow-sm" data-id="element-71">
          <Accordion type="single" collapsible className="w-full" data-id="element-72">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} className="border-gold/20" data-id="element-73">
                <AccordionTrigger className="font-serif text-lg md:text-xl text-charcoal hover:text-brick-red text-left hover:no-underline py-6 [&[data-state=open]>svg]:text-brick-red" data-id="element-74">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6" data-id="element-75">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="text-center mt-12" data-id="element-76">
          <a href="#" className="text-brick-red font-medium text-sm flex items-center justify-center hover:underline" data-id="element-77">
            See all FAQs <span className="ml-1" data-id="element-78">→</span>
          </a>
        </div>
      </div>
    </section>;
}